const adminRole = {
  ohbotAdmin: { name: '最高權限', value: 'ohbotAdmin' },
  ohbotSuccessAdmin: { name: '成功專員', value: 'ohbotSuccessAdmin' },
  ohbotGuset: { name: '訪客', value: 'ohbotGuset' },
  orgAdmin: { name: '集團管理員', value: 'orgAdmin' },
  shopManager: { name: '店家管理員', value: 'shopManager' },
  shopMod: { name: '店家店長', value: 'shopMod' },
  shopProvider: { name: '服務人員', value: 'shopProvider' },
  shopOperation: { name: '營運專員', value: 'shopOperation' },
  ohbotDemonAdmin: { name: 'DEMO', value: 'ohbotDemonAdmin' },
}

export default adminRole
